module.exports = __webpack_public_path__ + "img/slide_notic_cal.dbf70331.svg";